import React from "react";
import { Box, Chip, Divider, Stack, Typography } from "@mui/material";
import { formatPrice } from "../utils/formatters";

const Row = ({ name, children, testId }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }} data-testid={testId}>
    <Typography variant="body2" fontWeight={500} noWrap sx={{ minWidth: 0 }}>
      {name}
    </Typography>
    <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 1 }}>{children}</Box>
  </Box>
);

const Amount = ({ value }) => (
  <Typography variant="body2" fontWeight={500}>
    {value ? formatPrice(value) : "0 zł"}
  </Typography>
);

const NoteChip = ({ label }) => <Chip size="small" color="success" variant="outlined" label={label} />;

// Who pays for which seat in a group booking, and the total due. `own` is the
// booker's seat: {amount} in zł, or {amount: null, note, pending} while undecided
// or covered some other way. `preview` comes from POST /user_to_lesson/group-preview.
const GroupSummary = ({ preview, own, totalLabel = "Do zapłaty" }) => {
  if (!preview) return null;
  const ownKnown = own.amount !== null && own.amount !== undefined;
  const total = (ownKnown ? own.amount : 0) + (preview.friends_amount || 0);

  return (
    <Box
      data-testid="group-summary"
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 1.5 }}
    >
      <Stack spacing={1}>
        <Typography variant="subtitle2" fontWeight={600}>
          Kto za co płaci
        </Typography>
        <Row name="Ty">
          {ownKnown ? (
            <>
              {own.note && <NoteChip label={own.note} />}
              <Amount value={own.amount} />
            </>
          ) : (
            <Typography variant="caption" color={own.pending ? "warning.main" : "text.secondary"}>
              {own.note}
            </Typography>
          )}
        </Row>
        {preview.friends.map((friend) => (
          <Row key={friend.user_id} name={friend.full_name} testId="group-summary-friend">
            {friend.paid_with_own_pass && <NoteChip label="z własnego karnetu" />}
            <Amount value={friend.paid_with_own_pass ? 0 : preview.price} />
          </Row>
        ))}
        <Divider />
        <Box>
          <Row name={<strong>{ownKnown ? totalLabel : "Za znajomych"}</strong>}>
            <Typography variant="body1" fontWeight={700} data-testid="group-total">
              {total ? formatPrice(total) : "0 zł"}
            </Typography>
          </Row>
          {own.pending && (
            <Typography variant="caption" color="text.secondary">
              + Twoje miejsce po wybraniu płatności
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default GroupSummary;
